import { TokenIcon, NetworkIcon as UiNetworkIcon } from "@unizpay/ui";

/** Display names for the registry's symbols (packages/shared/src/registry.ts). */
const COIN_NAMES: Record<string, string> = {
  USDC: "USD Coin",
  "USDC.e": "Bridged USD Coin",
  USDbC: "Bridged USD Coin",
  USDT: "Tether USD",
  "USDT.e": "Bridged Tether USD",
  DAI: "Dai",
  ETH: "Ether",
  WETH: "Wrapped Ether",
  "WETH.e": "Wrapped Ether",
  WBTC: "Wrapped Bitcoin",
  "WBTC.e": "Wrapped Bitcoin",
  cbBTC: "Coinbase Wrapped BTC",
  BTCB: "Bitcoin BEP2",
  "BTC.b": "Bitcoin (Avalanche)",
  BNB: "BNB",
  WBNB: "Wrapped BNB",
  POL: "Polygon",
  WPOL: "Wrapped POL",
  AVAX: "Avalanche",
  WAVAX: "Wrapped AVAX",
  SOL: "Solana",
  TRX: "TRON",
};

export function coinName(symbol: string): string {
  return COIN_NAMES[symbol] ?? symbol;
}

/** The coin's logo (decorative: the symbol is always shown as text too); `network` adds its badge. */
export function CoinIcon({
  symbol,
  network,
  size = 32,
}: { symbol: string; network?: string; size?: number }) {
  return <TokenIcon symbol={symbol} network={network} size={size} />;
}

/** The network's logo, by its slug or chain id. */
export function NetworkIcon({ network, size = 24 }: { network: string; size?: number }) {
  return <UiNetworkIcon network={network} size={size} />;
}
